/**
 * All the functions that are used to send data to Google Tag Manager (GTM)
 * by using custom events and data layer variables.
 */

const pushTagManagerEvent = (eventName, eventData = {}) => {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: eventName,
		pricing: eventData,
	});
};

export const gtmEventChangePaymentInterval = ({ paymentInterval, plan }) => {
	pushTagManagerEvent('pricingChangePaymentInterval', {
		paymentInterval,
		plan,
	});
};

export const gtmEventShowFeatures = (plan) => {
	pushTagManagerEvent('pricingShowFeatures', {
		plan,
	});
};

export const gtmEventChangeUnits = ({ plan, units }) => {
	pushTagManagerEvent('pricingChangeUnits', {
		plan,
		units,
	});
};

export const gtmEventSelectPlan = ({ paymentInterval, plan, units }) => {
	pushTagManagerEvent('pricingSelectPlan', {
		paymentInterval,
		plan,
		units,
	});
};

export const gtmEventShowQuote = ({ consultingPackages, paymentInterval, plan, units }) => {
	pushTagManagerEvent('pricingShowQuote', {
		consultingPackages,
		paymentInterval,
		plan,
		units,
	});
};

export const gtmEventShareLink = () => {
	pushTagManagerEvent('pricingShareLink');
};

export const gtmEventClickQuoteLink = ({ linkText, linkUrl }) => {
	pushTagManagerEvent('pricingClickQuoteLink', {
		linkText,
		linkUrl,
	});
};
